import { useRemoteBool } from '@mrkt/features/RemoteConfig';

import { RemoteProperties } from './remoteProperties';

export function useArtistFundraisingPickSelfServeRollout() {
  return useRemoteBool(RemoteProperties.AFPSelfServe);
}
